import { Button, Typography } from '@mui/material'
import cx from 'classnames'
import { FC, MouseEventHandler, ReactNode } from 'react'
import { makeStyles } from 'tss-react/mui'

interface InfoMessageProps {
    icon: ReactNode
    message: string
    className?: string
    onClick?: MouseEventHandler<HTMLButtonElement>
}

export const InfoMessage: FC<InfoMessageProps> = ({
    icon,
    message,
    className,
    onClick,
}) => {
    const { classes: localClasses } = useLocalStyles()
    return onClick ? (
        <Button
            variant="text"
            startIcon={icon}
            onClick={onClick}
            className={cx(localClasses.infoMessage, className)}
        >
            <Typography className={localClasses.infoMessageText}>
                {message}
            </Typography>
        </Button>
    ) : (
        <div className={cx(localClasses.infoMessage, className)}>
            {icon}
            <Typography className={localClasses.infoMessageText}>
                {message}
            </Typography>
        </div>
    )
}

const useLocalStyles = makeStyles()({
    infoMessage: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    infoMessageText: {
        textDecorationLine: 'underline',
    },
})
